import React from "react";
import { Panel } from "../../shared";
import { Section } from "../../shared";
import { Link } from "react-router-dom";

const ApplyForEPAID = () => {
  document.title = "HWTS: EPAIDs";
  return (
    <div>
      <Section
        title={"Apply for a Hazardous Waste ID Number"}
        type={"standout"}
      />
      <section className="p-y-200--md">
        <div className="container text-center">
          <div className="row center-block">
            <div className="center-block">
              {/* <div className="m-b">
                <h2 className="epaid-title display m-b">
                  Apply for a
                  <span className="color-primary">
                    {" "}
                    Hazardous Waste ID Number!
                  </span>
                </h2>
              </div> */}
              <div className="id-container m-t-lg">
                <div className="group half fed-id-container">
                  <Panel
                    panelType="understated"
                    panelHeader="Federal EPA ID Number"
                    panelIcon="ca-gov-icon-capitol"
                    panelClass="fed-id-panel"
                    panelBody={
                      <div>
                        <p className="m-b id-desc fed-id-desc">
                          Generating greater than 100kgs of RCRA Hazardous Waste
                          and/or 1kg of acutely hazardous waste per calendar
                          month.
                        </p>
                        <br />
                        <div className="id-length-container">
                          <div className="half fed-temp">
                            <a
                              className="epaid-card-link"
                              href="https://www.epa.gov/hwgenerators/instructions-and-form-hazardous-waste-generators-transporters-and-treatment-storage-and"
                              target="_"
                            >
                              <div className="id-card shadow2 section-default text-center p-x-md p-b-lg epaid-card">
                                <span className="icon-block bg-blue-gradient rounded-50x">
                                  <i className="ca-gov-icon-time" />
                                </span>
                                <h3
                                  className="h3 m-b-sm"
                                  style={{ marginTop: 0 }}
                                >
                                  Temporary EPA ID
                                </h3>
                                <p className="m-b">
                                  Temporary ID Numbers are issued to people or
                                  businesses who do not normally handle
                                  hazardous waste.These ID Numbers are valid for{" "}
                                  <span style={{ color: "red" }}>90 days</span>.
                                </p>
                                {/* <span className="text-uppercase font-size-sm need-link">I need a Temporary EPA ID Number</span> */}
                              </div>
                            </a>
                          </div>
                          <div className="half fed-perm">
                            <a
                              className="epaid-card-link"
                              href="http://www.dtsc.ca.gov/IDManifest/myRCRAid.cfm"
                              target="_"
                            >
                              <div className="id-card shadow2 section-primary text-center p-x-md p-b-lg epaid-card">
                                <span className="icon-block bg-blue-gradient rounded-50x">
                                  <i className="ca-gov-icon-green" />
                                </span>
                                <h3
                                  className="h3 m-b-sm"
                                  style={{
                                    marginTop: 0,
                                    textDecoration: "none"
                                  }}
                                >
                                  Permanent EPA ID
                                </h3>
                                <p className="m-b">
                                  Permanent ID Numbers are issued to people or
                                  businesses who routinely generate or handle
                                  hazardous waste.
                                </p>
                                {/* <span className="text-uppercase font-size-sm need-link">I need a Permanent EPA ID Number</span> */}
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    }
                  />
                </div>
                <div className="group half state-id-container">
                  <Panel
                    panelType="default"
                    panelHeader="State ID Number"
                    panelHeaderStyle={{
                      backgroundColor: "#aff79b"
                    }}
                    panelIcon="ca-gov-icon-state"
                    panelClass="state-id-panel"
                    panelBody={
                      <div>
                        <p className="m-b id-desc state-id-desc">
                          All other waste
                        </p>
                        <br />
                        <div className="id-type-container">
                          <div className="half state-temp">
                            <a
                              className="epaid-card-link"
                              href="https://dtsc-web01.dtsc.ca.gov/epaid/default.aspx"
                              target="_"
                            >
                              <div className="id-card shadow2 section-default text-center p-x-md p-b-lg epaid-card">
                                <span className="icon-block bg-blue-gradient rounded-50x">
                                  <i className="ca-gov-icon-time" />
                                </span>
                                <h3
                                  className="h3 m-b-sm"
                                  style={{ marginTop: 0 }}
                                >
                                  Temporary State ID
                                </h3>
                                <p className="m-b">
                                  Temporary ID Numbers are issued to people or
                                  businesses who do not normally handle
                                  hazardous waste.These ID Numbers are valid for{" "}
                                  <span style={{ color: "red" }}>90 days</span>.
                                </p>
                                {/* <span className="text-uppercase font-size-sm need-link">I need a Temporary State ID Number</span> */}
                              </div>
                            </a>
                          </div>
                          <div className="half state-perm">
                            <a
                              className="epaid-card-link"
                              href="http://www.dtsc.ca.gov/HazardousWaste/upload/GISS_FORM_1358.pdf"
                              target="_"
                            >
                              <div className="id-card shadow2 section-primary text-center p-x-md p-b-lg epaid-card">
                                <span className="icon-block bg-blue-gradient rounded-50x">
                                  <i className="ca-gov-icon-ca-state" />
                                </span>
                                <h3
                                  className="h3 m-b-sm"
                                  style={{ marginTop: 0 }}
                                >
                                  Permanent State ID
                                </h3>
                                <p className="m-b">
                                  Permanent ID Numbers are issued to people or
                                  businesses who routinely generate or handle
                                  hazardous waste.
                                </p>
                                {/* <span className="text-uppercase font-size-sm need-link">I need a Permanent State ID Number</span> */}
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ApplyForEPAID;
